module.exports = __webpack_public_path__ + "img/youtube.8bbc44a7.png";